import { render } from "./ApiFormModal.vue?vue&type=template&id=58506b4a&scoped=true"
import script from "./ApiFormModal.vue?vue&type=script&lang=js"
export * from "./ApiFormModal.vue?vue&type=script&lang=js"

import "./ApiFormModal.vue?vue&type=style&index=0&id=58506b4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58506b4a"]])

export default __exports__